import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

const LaporanWargaPage = Loadable(lazy(() => import('pages/public/LaporanWarga')));

// ==============================|| PUBLIC ROUTING ||============================== //

const PublicRoutes = {
  path: '/',
  children: [
    {
      path: 'publik',
      children: [
        {
          path: 'laporan',
          element: <LaporanWargaPage />
        }
      ]
    }
  ]
};

export default PublicRoutes;
